export const GLOBAL_WHATSAPP_NUMBER = "5511985464552";

export const normalizeWhatsAppNumber = (raw?: string | null) => {
  if (!raw) return null;
  const digits = raw.replace(/\D/g, "");
  if (!digits) return null;
  if (digits.startsWith("55")) return digits;
  return `55${digits}`;
};

export const buildWhatsAppLink = (number: string, message?: string) => {
  if (!message) {
    return `https://wa.me/${number}`;
  }
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${number}?text=${encoded}`;
};
